import * as React from 'react';

import PasswordField, { PasswordStrength } from '../components/PasswordField';

/**
 * Provides the validation the informs the PasswordField component what to display
 * when a new password is being entered.
 */
export default class PasswordFieldContainer extends React.Component<
  PasswordFieldContainerProps,
  PasswordFieldContainerState
> {
  constructor(props: PasswordFieldContainerProps) {
    super(props);
    this.state = { passwordStrength: validatePassword(props.password) };
  }

  render() {
    return (
      <PasswordField
        {...this.props}
        onChange={this.handleChange}
        passwordStrength={this.state.passwordStrength}
      />
    );
  }

  handleChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    this.setState({ passwordStrength: validatePassword(value) });
    this.props.onChange(event);
  };
}

export interface PasswordFieldContainerProps {
  /** Optional class name to override styles */
  className?: string;

  /** Whether this field should be disabled */
  disabled?: boolean;

  /** Whether to focus this field as soon as it is rendered */
  autoFocus?: boolean;

  /** The currently entered password value */
  password: string;

  /** Callback to handle updates to the current password value */
  onChange(event: React.SyntheticEvent<HTMLInputElement>): void;
}

export interface PasswordFieldContainerState {
  /** Whether the current password is strong enough */
  passwordStrength: PasswordStrength;
}

export function passwordValid(password: string) {
  if (!password) {
    return false;
  }
  const strength = validatePassword(password);
  return strength.longEnough && strength.hasLowercase && strength.hasNumbers;
}

/**
 * Currently password validation is hard coded here. In a real word scenario this should be
 * delegating to, or at least replicating, validation logic on the server side.
 */
function validatePassword(password: string): PasswordStrength {
  return {
    longEnough: password.length >= 10,
    hasLowercase: password.match(/[a-z]/) !== null,
    hasNumbers: password.match(/[0-9]/) !== null
  };
}



// WEBPACK FOOTER //
// ./src/containers/PasswordField.tsx